var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5226 6.46204C19.8197 6.75066 19.8266 7.22548 19.538 7.52259L9.82368 17.5226C9.67991 17.6706 9.48152 17.7528 9.27521 17.7499C9.06889 17.747 8.87289 17.6593 8.73332 17.5073L4.44761 12.8406C4.16743 12.5356 4.18762 12.0611 4.4927 11.7809C4.79778 11.5008 5.27223 11.5209 5.5524 11.826L9.30103 15.9079L18.462 6.47741C18.7507 6.1803 19.2255 6.17342 19.5226 6.46204Z",
    fill: "#4169E1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSelected);
export default __webpack_public_path__ + "static/media/icon-selected.95613ffb3ec303c0e0b9d419dc5a70c5.svg";
export { ForwardRef as ReactComponent };